import ListTransferMissingAssigneesModal from './ListTransferMissingAssigneesModal';

export default ListTransferMissingAssigneesModal;
